import { Pipe, PipeTransform } from '@angular/core';
import { DropdownOptionPipe } from '@shared-ikp/pipes/dropdown-option.pipe';
import { BeraterReturnTypeMap, BeraterSupportedDropdownTypes, BeraterTransformerKeys } from '../utils/ikp-berater-dropdown-transformers';

@Pipe({ name: 'beraterDropdownOption', standalone: true })
export class BeraterDropdownOptionPipe
  extends DropdownOptionPipe<BeraterTransformerKeys, BeraterReturnTypeMap, BeraterSupportedDropdownTypes>
  implements PipeTransform
{
  override transform<K extends BeraterTransformerKeys>(input: BeraterSupportedDropdownTypes, transformerKey: K): BeraterReturnTypeMap[K][] {
    return super.transform(input, transformerKey);
  }
}
